import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";

export const notifyReviewChanged = () => window.dispatchEvent(new Event("review:changed"));

export function useReviewCount() {
  const [count, setCount] = useState(0);
  const load = useCallback(() => api.get("/captures/review-count").then((r) => setCount(r.data.count)).catch(() => {}), []);
  useEffect(() => {
    load();
    const t = setInterval(load, 30000);
    const h = () => setTimeout(load, 1500);
    window.addEventListener("review:changed", load);
    window.addEventListener("capture:uploaded", h);
    return () => { clearInterval(t); window.removeEventListener("review:changed", load); window.removeEventListener("capture:uploaded", h); };
  }, [load]);
  return count;
}
